// extracted by mini-css-extract-plugin
module.exports = {"pagination":"_2f6c14a5"};